/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_TitleInputs */

const en_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Preview (Magnified)`)
};

const fr_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previsualisation d'image (agrandie)`)
};

const de_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildvorschau (vergrößert)`)
};

const it_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima dell'immagine (ingrandita)`)
};

const ru_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр изображения (увеличенное)`)
};

const es_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de la imagen (ampliada)`)
};

const zh_cn2_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片预览（放大）`)
};

const ja_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像プレビュー（拡大）`)
};

const hi_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवि का पूर्वावलोकन (आवर्धित)`)
};

const pt_pt2_image_export_magnified_title = /** @type {(inputs: Image_Export_Magnified_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da imagem (ampliada)`)
};

/**
* | output |
* | --- |
* | "Image Preview (Magnified)" |
*
* @param {Image_Export_Magnified_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_title = /** @type {((inputs?: Image_Export_Magnified_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_magnified_title(inputs)
	if (locale === "de") return de_image_export_magnified_title(inputs)
	if (locale === "it") return it_image_export_magnified_title(inputs)
	if (locale === "ru") return ru_image_export_magnified_title(inputs)
	if (locale === "es") return es_image_export_magnified_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_magnified_title(inputs)
	if (locale === "ja") return ja_image_export_magnified_title(inputs)
	if (locale === "hi") return hi_image_export_magnified_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_magnified_title(inputs)
	return en_image_export_magnified_title(inputs)
});